<template>
    <form @submit.prevent="onClickSubmit">
        <div class="form-login">
            <div class="form-login__input_large">
                <input
                    v-model="login" 
                    placeholder="Email"
                />
            </div>
            <div class="form-login__input_large">
                <input
                    v-model="password" 
                    placeholder="Пароль"
                    type="password"
                />
            </div>
            <!-- <div class="form-login__input_large">
                <input
                    v-model="phone"
                    placeholder="Телефон"
                />
            </div> -->
            <div class="form-login__btn-container">
                <button
                    type="submit" 
                    class="form-login__btn_login"
                >
                    Войти
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: "FormAuthCheckPhone",
    /**
     * @property {string} login - логин
     * @property {string} password - пароль
     * @property {string} phone - логин
     */
    data: () => ({
        login: '',
        password: ''
        // phone: ''
    }),
    computed: {
        /**
         * данные формы
         * @returns {object}
         */
        // formData() {
        //     let data = {
        //         phone: this.phone
        //     };
        //     return data;
        // },
        /**
         * данные формы
         * @returns {object}
         */
        formData() {
            let data = {
                login: this.login,
                password: this.password
            };
            return data;
        }
    },
    methods: {
        /**
         * событие клика по кнопке
         */
        onClickSubmit() {
            this.$emit('submitForm', this.formData);
        }
    }
}
</script>

<style lang="scss" scoped>
    button:focus {
        outline: 0;
    }
    .form-login__input_large {
        position: relative;
    }
    %form-login-ui-content {
        font-size: 16px;
        height: 60px;
        border-radius: 60px;
        font-weight: bold;
        font-family: 'Segoe UI SemiBold';
        transition: all 250ms;
    }
    .form-login .form-login__input_large input {
        @extend %form-login-ui-content;
        width: 100%;
        background: #fff;
        border: 1px solid #fff;
        outline: 0;
        padding: 0 40px;
        margin-bottom: 10px;
        box-sizing: border-box;
    }
    .form-login__btn-container {
        text-align: center;
        margin-top: 20px;
    }
    .form-login__btn_login {
        @extend %form-login-ui-content;
        background: #2686e6;
        color: #fff;
        text-align: center;
        width: 60%;
        cursor: pointer;
        border: 0;
    }
    .form-login__btn_login:hover {
        background: #1f79d2;
    }
</style>